export enum PodugovorTabEnum {
  Korekcije = 'korekcije',
  KorekcijeAneks = 'korekcijeAneks',
  CiljneGrupe = 'ciljneGrupe',
  CiljneGrupeAneks = 'ciljneGrupeAneks',
  Oglasivaci = 'oglasivaci',
  OglasivaciAneks = 'oglasivaciAneks',
  Spotovi = 'spotovi',
  SpotoviAneks = 'spotoviAneks',
  CenePoOdluci = 'cenePoOdluci',
  CenePoOdluciAneks = 'cenePoOdluciAneks',
  SponzorstvoEmisija = 'sponzorstvoEmisija',
  SponzorstvoEmisijaAneks = 'sponzorstvoEmisijaAneks',
  SponzorstvoCena = 'sponzorstvoCena',
  SponzorstvoCenaAneks = 'sponzorstvoCenaAneks',
  CppCene = 'cppCene',
  CppCeneAneks = 'cppCeneAneks',
  BrendiraneSpice = 'brendiraneSpice',
  BrendiraneSpiceAneks = 'brendiraneSpiceAneks'
}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/ugovori/enums/podugovor-tab.enum.ts